import {
  withGlobalDialog,
  withGlobalConfirmDialog,
  withGlobalPromptDialog,
  withGlobalExceptionDetailDialog,
  withGlobalLoginDialog,
} from '../hoc';
import { ConfirmDialog, PromptDialog, CommentsDialog } from '../components/dialog';
import LoadingProgress from '../components/loading-progress';
import ExceptionDetail from '../components/dialog/exception-detail';
import LoginDialog from '../components/dialog/login-dialog';

const dialog = {};

export const GlobalLoadingProgress = withGlobalDialog(
  LoadingProgress,
  (value) => { dialog.loadingProgress = value; },
);
export const GlobalConfirmDialog = withGlobalConfirmDialog(
  ConfirmDialog,
  (value) => { dialog.confirm = value; },
);
export const GlobalPromptDialog = withGlobalPromptDialog(
  PromptDialog,
  (value) => { dialog.prompt = value; },
);
export const GlobalExceptionDetailDialog = withGlobalExceptionDetailDialog(
  ExceptionDetail,
  (value) => { dialog.exceptionDetail = value; },
);
export const GlobalLoginDialog = withGlobalLoginDialog(
  LoginDialog,
  (value) => { dialog.login = value; },
);

export default dialog;
